import { isEmpty } from 'underscore';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import { FluxibleActions, loadingStates } from 'bundles/discussions/constants';
import { hydrateSearchResults } from 'bundles/discussions/utils/hydrateSearchResults';

const buildSearchResultsKey = (forumId: $TSFixMe, query: $TSFixMe, pageNum: $TSFixMe) => `${forumId}~${pageNum}`;
const buildQueryBasedKey = (forumId: $TSFixMe, query: $TSFixMe) => `${forumId}~${query}`;

class SearchStore extends BaseStore {
  static storeName = 'DiscussionsSearchStore';

  static handlers = {
    [FluxibleActions.SEARCH_RESULTS_RECEIVED]({
      naptimeResponse,
      pageNum,
      filterQueryString,
      forumId,
      query,
    }: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentPage' does not exist on type '{ S... Remove this comment to see the full error message
      this.currentPage = pageNum;

      // @ts-expect-error ts-migrate(2339) FIXME: Property '_searchResults' does not exist on type '... Remove this comment to see the full error message
      this._searchResults[buildSearchResultsKey(forumId, query, this.currentPage)] =
        hydrateSearchResults(naptimeResponse);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'pageCount' does not exist on type '{ SEA... Remove this comment to see the full error message
      this.pageCount[buildQueryBasedKey(forumId, query)] = Math.ceil(naptimeResponse.paging.total / 15);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'numResults' does not exist on type '{ SE... Remove this comment to see the full error message
      this.numResults[buildQueryBasedKey(forumId, query)] = naptimeResponse.paging.total;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type '{ ... Remove this comment to see the full error message
      this.loadingState = loadingStates.DONE;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ SE... Remove this comment to see the full error message
      this.emitChange();
    },

    [FluxibleActions.SEARCH_PAGE_CHANGE]({ pageNum, filterQueryString, naptimeResponse, forumId, query }: $TSFixMe) {
      // TODO: We don't do anything with filterQueryString because we're just resetting
      // the store when filterQueryString changes ... but think about actually
      // storing all results indexing by an additional filterQueryString.
      if (naptimeResponse) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property '_searchResults' does not exist on type '... Remove this comment to see the full error message
        this._searchResults[buildSearchResultsKey(forumId, query, pageNum)] = hydrateSearchResults(naptimeResponse);
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'pageCount' does not exist on type '{ SEA... Remove this comment to see the full error message
        this.pageCount[buildQueryBasedKey(forumId, query)] = Math.ceil(naptimeResponse.paging.total / 15);
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'numResults' does not exist on type '{ SE... Remove this comment to see the full error message
        this.numResults[buildQueryBasedKey(forumId, query)] = naptimeResponse.paging.total;
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type '{ ... Remove this comment to see the full error message
      this.loadingState = loadingStates.DONE;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentPage' does not exist on type '{ S... Remove this comment to see the full error message
      this.currentPage = pageNum;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ SE... Remove this comment to see the full error message
      this.emitChange();
    },

    [FluxibleActions.SEARCH_API_ERROR]() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type '{ ... Remove this comment to see the full error message
      this.loadingState = loadingStates.ERROR;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ SE... Remove this comment to see the full error message
      this.emitChange();
    },

    [FluxibleActions.UPDATE_LOADING_STATE](loadingState: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type '{ ... Remove this comment to see the full error message
      this.loadingState = loadingState;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ SE... Remove this comment to see the full error message
      this.emitChange();
    },

    [FluxibleActions.CLEAR_DISCUSSIONS_SEARCH_STORE]() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentPage' does not exist on type '{ S... Remove this comment to see the full error message
      this.currentPage = 1;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'pageCount' does not exist on type '{ SEA... Remove this comment to see the full error message
      this.pageCount = {};
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'numResults' does not exist on type '{ SE... Remove this comment to see the full error message
      this.numResults = {};
      // @ts-expect-error ts-migrate(2339) FIXME: Property '_loadingState' does not exist on type '{... Remove this comment to see the full error message
      this._loadingState = loadingStates.LOADING;
      // @ts-expect-error ts-migrate(2339) FIXME: Property '_searchResults' does not exist on type '... Remove this comment to see the full error message
      this._searchResults = {};
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ SE... Remove this comment to see the full error message
      this.emitChange();
    },
  };

  constructor(dispatcher: $TSFixMe) {
    super(dispatcher);

    // Public
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentPage' does not exist on type 'Sea... Remove this comment to see the full error message
    this.currentPage = 1;

    // keyed on forumId~query
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'pageCount' does not exist on type 'Searc... Remove this comment to see the full error message
    this.pageCount = {};
    // keyed on forumId~query
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'numResults' does not exist on type 'Sear... Remove this comment to see the full error message
    this.numResults = {};

    // Private, access using getters/setters
    // @ts-expect-error ts-migrate(2551) FIXME: Property '_loadingState' does not exist on type 'S... Remove this comment to see the full error message
    this._loadingState = loadingStates.LOADING;

    // compound key of forumId~pageNum
    // @ts-expect-error ts-migrate(2551) FIXME: Property '_searchResults' does not exist on type '... Remove this comment to see the full error message
    this._searchResults = {};
  }

  get query() {
    // @ts-expect-error ts-migrate(2551) FIXME: Property '_query' does not exist on type 'SearchSt... Remove this comment to see the full error message
    return this._query;
  }

  set query(query) {
    // @ts-expect-error ts-migrate(2551) FIXME: Property '_query' does not exist on type 'SearchSt... Remove this comment to see the full error message
    this._query = decodeURIComponent(query);
  }

  get loadingState() {
    // @ts-expect-error ts-migrate(2551) FIXME: Property '_loadingState' does not exist on type 'S... Remove this comment to see the full error message
    return this._loadingState;
  }

  set loadingState(state) {
    if (
      Object.keys(loadingStates)
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        .map((key) => loadingStates[key])
        .indexOf(state) < 0
    ) {
      throw new Error('Invalid loading state');
    }

    // @ts-expect-error ts-migrate(2551) FIXME: Property '_loadingState' does not exist on type 'S... Remove this comment to see the full error message
    this._loadingState = state;
  }

  searchResults(options = {}) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumId' does not exist on type '{}'.
    const { forumId, pageNum, query } = options;

    if (!forumId) {
      // @ts-expect-error ts-migrate(2551) FIXME: Property '_searchResults' does not exist on type '... Remove this comment to see the full error message
      return isEmpty(this._searchResults) ? null : this._searchResults;
    }

    // @ts-expect-error ts-migrate(2551) FIXME: Property '_searchResults' does not exist on type '... Remove this comment to see the full error message
    return this._searchResults[buildSearchResultsKey(forumId, query, pageNum)] || [];
  }

  getNumResults(options = {}) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumId' does not exist on type '{}'.
    const { forumId, query } = options;

    if (!forumId) {
      return 0;
    }

    // Treat no query as a query on empty string.
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'numResults' does not exist on type 'Sear... Remove this comment to see the full error message
    return this.numResults[buildQueryBasedKey(forumId, query || '')] || 0;
  }

  getPageCount(options = {}) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumId' does not exist on type '{}'.
    const { forumId, query } = options;

    if (!forumId) {
      return 0;
    }

    // Treat no query as a query on empty string.
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'pageCount' does not exist on type 'Searc... Remove this comment to see the full error message
    return this.pageCount[buildQueryBasedKey(forumId, query || '')] || 0;
  }
}

export default SearchStore;
